import React, { useMemo, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import useAuth from '@hooks/useAuth';
import useProductContext from '@hooks/useProductContext';
import tricorService from '@services/tricorService';
import _capitalize from 'lodash/capitalize';
import _get from 'lodash/get';

import {
  creditMenuLinks,
  prepaidMenuLinks,
  commonMenuLinks,
} from './menuLinks';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import UserMenu from './UserMenu';
import { PATHS } from '../../Routes';

// eslint-disable-next-line max-statements
export default function Header() {
  const [{ isAuthenticated, profile }, { logout }] = useAuth();
  const [
    { selectedProduct, isSelectedCreditProduct, isSelectedPrepaidProduct },
  ] = useProductContext();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [showSuperWithdrawal, setShowSuperWithdrawal] = useState(false);
  const [header, setHeader] = useState(true);
  console.log('v.04/11/26 - update fec');
  const checkSuperWithdrawal = async () => {
    const { data } = await tricorService(64, {
      origin: 'SUPERWITHDRAWAL',
      identificationNumber: _get(profile, 'id'), // RUT del cliente sin puntos ni guión
    });
    setShowSuperWithdrawal(_get(data, 'feasibility', false));
  };

  const location = useLocation();
  const currentUrl = location.pathname;
  useEffect(() => {
    if (isAuthenticated) {
      checkSuperWithdrawal();
    }
    if (currentUrl !== '/actualiza-clave') {
      setHeader(true);
    } else {
      setHeader(false);
    }
    // eslint-disable-next-line
  }, [isAuthenticated, currentUrl]);

  const customerName = _get(selectedProduct, 'profile.name', '')
    .split(' ')
    .map((word) => _capitalize(word))
    .join(' ');

  const [{ hasCreditProduct, hasPrepaidProduct }] = useProductContext();
  const menuLinks = useMemo(() => {
    let sourceLinks = [];
    // En /actualiza-clave no se muestra menú para no saltarse el cambio de clave
    if (!header) {
      sourceLinks = [];
    } else if (
      hasCreditProduct &&
      hasPrepaidProduct &&
      location.pathname === PATHS.HOME
    ) {
      sourceLinks = commonMenuLinks;
    } else if (isSelectedCreditProduct) {
      sourceLinks = creditMenuLinks;
    } else if (isSelectedPrepaidProduct) {
      sourceLinks = prepaidMenuLinks;
    }

    return sourceLinks;
  }, [
    hasCreditProduct,
    hasPrepaidProduct,
    isSelectedCreditProduct,
    isSelectedPrepaidProduct,
    location.pathname,
    header,
  ]);
  return useMemo(
    () => (
      <div className='header'>
        <div className='container-fluid'>
          <div className='container-header'>
            {header ? (
              <div className='logo'>
                <Link to={PATHS.HOME}>
                  <img alt='tricard' src='/assets/img/tricot-visa.svg' />
                </Link>
              </div>
            ) : (
              <div className='logo'>
                <img alt='tricard' src='/assets/img/tricot-visa.svg' />
              </div>
            )}
            <div className='user'>
              {isAuthenticated && customerName && (
                <p>Bienvenido, {customerName}</p>
              )}
              {isAuthenticated && header && (
                <div className='header-right'>
                  <UserMenu setOpenSidebar={setOpenSidebar} />
                </div>
              )}
              {isAuthenticated && (
                <button className='icon-logout' onClick={() => logout()}>
                  <img alt='Cerrar sesion' src='/assets/img/logout-icon.svg' />
                </button>
              )}
            </div>
          </div>
          <Navbar
            customerName={customerName}
            lockNavigation={!header}
            menuLinks={menuLinks}
            openSidebar={openSidebar}
            setOpenSidebar={setOpenSidebar}
            showSuperWithdrawal={showSuperWithdrawal}
          />
          {header && (
            <Sidebar
              formattedName={customerName}
              menuLinks={menuLinks}
              openSidebar={openSidebar}
              setOpenSidebar={setOpenSidebar}
              showSuperWithdrawal={showSuperWithdrawal}
            />
          )}
        </div>
      </div>
    ),
    [
      customerName,
      header,
      isAuthenticated,
      menuLinks,
      openSidebar,
      showSuperWithdrawal,
      logout,
    ]
  );
}
